import { FC } from 'react'
import { ContactAddressType } from '../../../../../../common/ContactAddress.type'
import FirstCardContent from './FirstCardContent'
import SecondCardContent from './SecondCardContent'
import ThirdCardContent from './ThirdCardContent'

type Props = {
  contactAddress: ContactAddressType
}

const CardContent: FC<Props> = (props) => {
  const { contactAddress } = props

  return (
    <div className="stack-small">
      <FirstCardContent contactAddress={contactAddress} />

      <SecondCardContent contactAddress={contactAddress} />

      <ThirdCardContent contactAddress={contactAddress} />
    </div>
  )
}

export default CardContent
